import axios from 'axios';
import {
    UPLOAD_BATCH_LIST_REQUEST, UPLOAD_BATCH_LIST_SUCCESS, UPLOAD_BATCH_LIST_FAIL,
    UPLOAD_BATCH_LIST_BY_IDS_REQUEST, UPLOAD_BATCH_LIST_BY_IDS_SUCCESS, UPLOAD_BATCH_LIST_BY_IDS_FAIL,
    UPLOAD_BATCH_DETAILS_REQUEST, UPLOAD_BATCH_DETAILS_SUCCESS, UPLOAD_BATCH_DETAILS_FAIL,
    UPLOAD_BATCH_CREATE_REQUEST, UPLOAD_BATCH_CREATE_SUCCESS, UPLOAD_BATCH_CREATE_FAIL,
    UPLOAD_BATCH_UPDATE_REQUEST, UPLOAD_BATCH_UPDATE_SUCCESS, UPLOAD_BATCH_UPDATE_FAIL,
    UPLOAD_BATCH_DELETE_REQUEST, UPLOAD_BATCH_DELETE_SUCCESS, UPLOAD_BATCH_DELETE_FAIL,
    UPLOAD_BATCH_DTO_REQUEST, UPLOAD_BATCH_DTO_SUCCESS, UPLOAD_BATCH_DTO_FAIL,
    UPLOAD_BATCH_BY_ORGANISATION_REQUEST, UPLOAD_BATCH_BY_ORGANISATION_SUCCESS, UPLOAD_BATCH_BY_ORGANISATION_FAIL,
    UPLOAD_BATCH_BY_PATIENT_REQUEST, UPLOAD_BATCH_BY_PATIENT_SUCCESS, UPLOAD_BATCH_BY_PATIENT_FAIL,
    UPLOAD_BATCH_BY_STATUS_REQUEST, UPLOAD_BATCH_BY_STATUS_SUCCESS, UPLOAD_BATCH_BY_STATUS_FAIL,
    UPLOAD_BATCH_BY_FILEPATH_REQUEST, UPLOAD_BATCH_BY_FILEPATH_SUCCESS, UPLOAD_BATCH_BY_FILEPATH_FAIL,
    UPLOAD_BATCH_PROCESSING_JOBS_REQUEST, UPLOAD_BATCH_PROCESSING_JOBS_SUCCESS, UPLOAD_BATCH_PROCESSING_JOBS_FAIL,
    UPLOAD_BATCH_SUBJECTS_REQUEST, UPLOAD_BATCH_SUBJECTS_SUCCESS, UPLOAD_BATCH_SUBJECTS_FAIL,
    UPLOAD_BATCH_SEND_BATCH_REQUEST, UPLOAD_BATCH_SEND_BATCH_SUCCESS, UPLOAD_BATCH_SEND_BATCH_FAIL, UPLOAD_BATCH_SEND_BATCH_RESET,
} from '../constants/uploadBatchConstants';
import { formatApiError } from '../utils/formatApiError';

// Helper functions
const getAuthConfig = (token) => ({
    headers: {
        'Content-type': 'application/json',
        'Authorization': `Bearer ${token}`
    }
});

const formatErrorMessage = (error) => {
    if (error.response?.status === 403) {
        return [formatApiError(error)];
    }
    const errorMessages = [];
    if (error.response?.data) {
        if (error.response.data.errors) {
            Object.entries(error.response.data.errors).forEach(([key, value]) => {
                errorMessages.push(`${key}: ${value[0]}`);
            });
        }
        if (error.response.data.detail) {
            errorMessages.push(`Detail: ${error.response.data.detail}`);
        }
        if (error.response.data.message) {
            errorMessages.push(`Message: ${error.response.data.message}`);
        }
        if (error.response.data.policy) {
            errorMessages.push(`Missing required policy: ${error.response.data.policy}`);
        }
    }
    return errorMessages.length > 0 ? errorMessages : [error.message || "An error occurred, please try again later"];
};

const API_BASE_URL = '/dotnet_api/v1/uploadbatch';

export const listUploadBatches = (params = {}) => async (dispatch, getState) => {
    try {
        dispatch({ type: UPLOAD_BATCH_LIST_REQUEST });
        const config = {
            ...getAuthConfig(getState().userLogin.userInfo.token),
            params
        };
        const { data } = await axios.get(`${API_BASE_URL}/all`, config);
        dispatch({ type: UPLOAD_BATCH_LIST_SUCCESS, payload: data });
    } catch (error) {
        dispatch({
            type: UPLOAD_BATCH_LIST_FAIL,
            payload: formatErrorMessage(error)
        });
    }
};

export const listUploadBatchesByIds = (ids) => async (dispatch, getState) => {
    try {
        dispatch({ type: UPLOAD_BATCH_LIST_BY_IDS_REQUEST });
        const { data } = await axios.post(
            `${API_BASE_URL}/ids/all`,
            ids,
            getAuthConfig(getState().userLogin.userInfo.token)
        );
        dispatch({ type: UPLOAD_BATCH_LIST_BY_IDS_SUCCESS, payload: data });
    } catch (error) {
        dispatch({
            type: UPLOAD_BATCH_LIST_BY_IDS_FAIL,
            payload: formatErrorMessage(error)
        });
    }
};

export const getUploadBatchDetails = (id) => async (dispatch, getState) => {
    try {
        dispatch({ type: UPLOAD_BATCH_DETAILS_REQUEST });
        const config = getAuthConfig(getState().userLogin.userInfo.token);
        const { data } = await axios.get(`${API_BASE_URL}/${id}`, config);
        dispatch({
            type: UPLOAD_BATCH_DETAILS_SUCCESS,
            payload: data
        });
    } catch (error) {
        dispatch({
            type: UPLOAD_BATCH_DETAILS_FAIL,
            payload: formatErrorMessage(error)
        });
    }
};

export const createUploadBatch = (uploadBatchData) => async (dispatch, getState) => {
    try {
        dispatch({ type: UPLOAD_BATCH_CREATE_REQUEST });
        const { data } = await axios.post(
            API_BASE_URL,
            uploadBatchData,
            getAuthConfig(getState().userLogin.userInfo.token)
        );
        dispatch({ type: UPLOAD_BATCH_CREATE_SUCCESS, payload: data });
    } catch (error) {
        dispatch({
            type: UPLOAD_BATCH_CREATE_FAIL,
            payload: formatErrorMessage(error)
        });
    }
};

export const updateUploadBatch = (id, changes) => async (dispatch, getState) => {
    try {
        dispatch({ type: UPLOAD_BATCH_UPDATE_REQUEST });
        const { data } = await axios.patch(
            `${API_BASE_URL}/${id}`,
            changes,
            getAuthConfig(getState().userLogin.userInfo.token)
        );
        dispatch({ type: UPLOAD_BATCH_UPDATE_SUCCESS, payload: data });
    } catch (error) {
        dispatch({
            type: UPLOAD_BATCH_UPDATE_FAIL,
            payload: formatErrorMessage(error)
        });
    }
};

export const deleteUploadBatch = (id) => async (dispatch, getState) => {
    try {
        dispatch({ type: UPLOAD_BATCH_DELETE_REQUEST });
        await axios.delete(
            `${API_BASE_URL}/${id}`,
            getAuthConfig(getState().userLogin.userInfo.token)
        );
        dispatch({ type: UPLOAD_BATCH_DELETE_SUCCESS });
    } catch (error) {
        dispatch({
            type: UPLOAD_BATCH_DELETE_FAIL,
            payload: formatErrorMessage(error)
        });
    }
};

export const loadUploadBatchDto = () => async (dispatch, getState) => {
    try {
        dispatch({ type: UPLOAD_BATCH_DTO_REQUEST });
        const { data } = await axios.get(
            `${API_BASE_URL}/dto`,
            getAuthConfig(getState().userLogin.userInfo.token)
        );
        dispatch({ type: UPLOAD_BATCH_DTO_SUCCESS, payload: data });
    } catch (error) {
        dispatch({
            type: UPLOAD_BATCH_DTO_FAIL,
            payload: formatErrorMessage(error)
        });
    }
};

// Custom actions for UploadBatch specific functionality
export const getUploadBatchesByOrganisation = (organisationId) => async (dispatch, getState) => {
    try {
        dispatch({ type: UPLOAD_BATCH_BY_ORGANISATION_REQUEST });
        const config = getAuthConfig(getState().userLogin.userInfo.token);
        const { data } = await axios.get(`${API_BASE_URL}/organisation/${organisationId}`, config);
        dispatch({ type: UPLOAD_BATCH_BY_ORGANISATION_SUCCESS, payload: data });
    } catch (error) {
        dispatch({
            type: UPLOAD_BATCH_BY_ORGANISATION_FAIL,
            payload: formatErrorMessage(error)
        });
    }
};

export const getUploadBatchesByPatient = (patientId) => async (dispatch, getState) => {
    try {
        dispatch({ type: UPLOAD_BATCH_BY_PATIENT_REQUEST });
        const config = getAuthConfig(getState().userLogin.userInfo.token);
        const { data } = await axios.get(`${API_BASE_URL}/patient/${patientId}`, config);
        dispatch({ type: UPLOAD_BATCH_BY_PATIENT_SUCCESS, payload: data });
    } catch (error) {
        dispatch({
            type: UPLOAD_BATCH_BY_PATIENT_FAIL,
            payload: formatErrorMessage(error)
        });
    }
};

export const getUploadBatchesByStatus = (status) => async (dispatch, getState) => {
    try {
        dispatch({ type: UPLOAD_BATCH_BY_STATUS_REQUEST });
        const config = getAuthConfig(getState().userLogin.userInfo.token);
        const { data } = await axios.get(`${API_BASE_URL}/status/${status}`, config);
        dispatch({ type: UPLOAD_BATCH_BY_STATUS_SUCCESS, payload: data });
    } catch (error) {
        dispatch({
            type: UPLOAD_BATCH_BY_STATUS_FAIL,
            payload: formatErrorMessage(error)
        });
    }
};

export const getUploadBatchByFilePath = (filePath) => async (dispatch, getState) => {
    try {
        dispatch({ type: UPLOAD_BATCH_BY_FILEPATH_REQUEST });
        const config = {
            ...getAuthConfig(getState().userLogin.userInfo.token),
            params: { filePath }
        };
        const { data } = await axios.get(`${API_BASE_URL}/filepath`, config);
        dispatch({ type: UPLOAD_BATCH_BY_FILEPATH_SUCCESS, payload: data });
    } catch (error) {
        dispatch({
            type: UPLOAD_BATCH_BY_FILEPATH_FAIL,
            payload: formatErrorMessage(error)
        });
    }
};

// New paginated endpoints for upload batch relationships
export const getUploadBatchProcessingJobs = (uploadBatchId, params = {}) => async (dispatch, getState) => {
    try {
        dispatch({ type: UPLOAD_BATCH_PROCESSING_JOBS_REQUEST });
        const config = {
            ...getAuthConfig(getState().userLogin.userInfo.token),
            params
        };
        const { data } = await axios.get(`${API_BASE_URL}/${uploadBatchId}/processing-jobs`, config);
        dispatch({ type: UPLOAD_BATCH_PROCESSING_JOBS_SUCCESS, payload: data });
    } catch (error) {
        dispatch({
            type: UPLOAD_BATCH_PROCESSING_JOBS_FAIL,
            payload: formatErrorMessage(error)
        });
    }
};

export const getUploadBatchSubjects = (uploadBatchId, params = {}) => async (dispatch, getState) => {
    try {
        dispatch({ type: UPLOAD_BATCH_SUBJECTS_REQUEST });
        const config = {
            ...getAuthConfig(getState().userLogin.userInfo.token),
            params
        };
        const { data } = await axios.get(`${API_BASE_URL}/${uploadBatchId}/subjects`, config);
        dispatch({ type: UPLOAD_BATCH_SUBJECTS_SUCCESS, payload: data });
    } catch (error) {
        dispatch({
            type: UPLOAD_BATCH_SUBJECTS_FAIL,
            payload: formatErrorMessage(error)
        });
    }
};

export const sendBatch = (uploadBatchId) => async (dispatch, getState) => {
    try {
        dispatch({ type: UPLOAD_BATCH_SEND_BATCH_REQUEST });
        const { data } = await axios.patch(
            `${API_BASE_URL}/${uploadBatchId}/send-batch`,
            {},
            getAuthConfig(getState().userLogin.userInfo.token)
        );
        dispatch({ type: UPLOAD_BATCH_SEND_BATCH_SUCCESS, payload: data });
    } catch (error) {
        dispatch({
            type: UPLOAD_BATCH_SEND_BATCH_FAIL,
            payload: formatErrorMessage(error)
        });
    }
}; 